import { lazy } from '../../shared/deployment';

export {
  useIsActive,
  useSettings,
} from './model/hooks.js';

export const AppRecommendations = lazy(() => import('./ui/AppRecommendations'));
